export default __webpack_public_path__ + "static/media/time.885a7161.svg";